require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-randy-glassburn-ball-state-financial-president-retires.json") })
        }
      }, "path---articles-randy-glassburn-ball-state-financial-president-retires");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-randy-glassburn-ball-state-financial-president-retires!./.cache/json/articles-randy-glassburn-ball-state-financial-president-retires.json
// module id = 1723
// module chunks = 231608221292675